export enum TokenType {
  ACCESS = 'access',
  ID = 'id',
  REFRESH = 'refresh'
}
